import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Checkbox = React.forwardRef(
  (
    {
      className = null,
      type = 'checkbox',
      id,
      label,
      defaultChecked = false,
      error = null,
      ...otherProps
    },
    ref
  ) => {
    return (
      <div className={classNames('checkbox', { checkbox_invalid: error }, className)}>
        <input
          className="checkbox__input"
          type={type}
          id={id}
          defaultChecked={defaultChecked}
          ref={ref}
          {...otherProps}
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control -- label text is injected via dangerouslySetInnerHTML, which the rule can't detect */}
        <label className="checkbox__label" htmlFor={id}>
          <span dangerouslySetInnerHTML={{ __html: label }} />
        </label>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultChecked: PropTypes.bool,
  error: PropTypes.bool,
};

export default Checkbox;
